import api from "../../api/axios";

function generateRequestId() {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  return `est-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export async function cadastrarFichaTrilhosNovos({ form, rows, requestId }) {
  const request_id = requestId || generateRequestId();
  const payload = {
    form: form || {},
    rows: Array.isArray(rows) ? rows : [],
    request_id,
  };

  const { data } = await api.post("/estaleiro/cadastro_trilhos_novos/cadastrar", payload, {
    headers: { "X-Idempotency-Key": request_id },
    timeout: 60000,
  });

  return data?.data || null;
}

export async function cadastrarFichaTrilhosReemprego({ form, rows, requestId }) {
  const request_id = requestId || generateRequestId();
  const payload = {
    form: form || {},
    rows: Array.isArray(rows) ? rows : [],
    request_id,
  };

  const { data } = await api.post("/estaleiro/cadastro_trilhos_reemprego/cadastrar", payload, {
    headers: { "X-Idempotency-Key": request_id },
    timeout: 60000,
  });

  return data?.data || null;
}

export async function listarBarrasDeposito(filters = {}) {
  const params = {};
  if (filters.tipo_lote) params.tipo_lote = filters.tipo_lote;
  if (filters.origem_fluxo) params.origem_fluxo = filters.origem_fluxo;
  if (filters.perfil_trilho) params.perfil_trilho = filters.perfil_trilho;
  if (filters.classe_trilho) params.classe_trilho = filters.classe_trilho;
  if (filters.data_de) params.data_de = filters.data_de;
  if (filters.data_ate) params.data_ate = filters.data_ate;
  if (filters.q) params.q = filters.q;
  if (Number.isFinite(Number(filters.limit))) params.limit = Number(filters.limit);
  if (Number.isFinite(Number(filters.offset))) params.offset = Number(filters.offset);

  const { data } = await api.get("/estaleiro/barras", {
    params,
    timeout: 60000,
  });

  return Array.isArray(data?.data) ? data.data : [];
}

export async function listarLotesDeposito(filters = {}) {
  const params = {};
  if (filters.tipo_lote) params.tipo_lote = filters.tipo_lote;
  if (filters.origem_fluxo) params.origem_fluxo = filters.origem_fluxo;
  if (filters.perfil_trilho) params.perfil_trilho = filters.perfil_trilho;
  if (filters.data_de) params.data_de = filters.data_de;
  if (filters.data_ate) params.data_ate = filters.data_ate;
  if (filters.q) params.q = filters.q;
  if (Number.isFinite(Number(filters.limit))) params.limit = Number(filters.limit);
  if (Number.isFinite(Number(filters.offset))) params.offset = Number(filters.offset);

  const { data } = await api.get("/estaleiro/lotes", {
    params,
    timeout: 60000,
  });

  return Array.isArray(data?.data) ? data.data : [];
}

export async function obterLoteDeposito(codigoLote) {
  const code = String(codigoLote ?? "").trim();
  if (!code) return null;

  const { data } = await api.get(`/estaleiro/lotes/${encodeURIComponent(code)}`, {
    timeout: 60000,
  });

  return data?.data || null;
}

export async function atualizarDocumentosLoteDeposito(codigoLote, payload = {}) {
  const code = String(codigoLote ?? "").trim();
  if (!code) return null;

  const body = {
    nota_fiscal: payload?.nota_fiscal ?? payload?.notas_fiscais ?? "",
    pedido_transferencia: payload?.pedido_transferencia ?? payload?.pedidos_transferencia ?? "",
  };

  const { data } = await api.put(`/estaleiro/lotes/${encodeURIComponent(code)}/documentos`, body, {
    timeout: 60000,
  });

  return data?.data || null;
}
